module.exports = __webpack_public_path__ + "static/img/img_media07.3e384af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners_pc/img_media07.png
// module id = X1in
// module chunks = 0